export enum EPropertyType {
  LEASE = 'lease',
  Mortgage = 'mortgage',
  NONE = 'none'
}
